var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"kt-checkbox kt-checkbox--single m-0 p-0",class:[
    {'kt-checkbox--solid': _vm.solid},
    {'kt-checkbox-hidden': _vm.disabled && _vm.hideOnDisabled},
    _vm.labelClass
  ]},[_c('input',{attrs:{"id":_vm.inputId,"disabled":_vm.disabled,"readonly":_vm.readonly,"name":_vm.name,"tabindex":_vm.tabindex,"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.onChange}}),_vm._v(" "),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }